import useSignOut from 'react-auth-kit/hooks/useSignOut'
import AuthService from '../services/AuthService'
import { useNavigate } from 'react-router-dom'

const useLogout = () => {
    const signOut = useSignOut()
    const navigate = useNavigate()

    const logout = async (redirect?: string) => {
        const response = await new AuthService().logout()
        if (response.status === 200) {
            signOut()
            if (redirect) navigate(redirect)
        }
        return response
    }

    return logout
}

export default useLogout
